"use client";

import { c as _c } from "react/compiler-runtime";
import { FaCheckCircle } from "react-icons/fa";
import { Tooltip } from "@/components/ui";
import { useSignOffDetails } from "@/lib/get-sign-off-tooltip-content";
import { cx } from "@/lib/tailwind-utils";
type SignOffLike = {
  signedOffProviderId?: string;
  signedOffDate?: string | Date;
};
interface SignedOffProps {
  signOff: SignOffLike;
  className?: string;
  iconClassName?: string;
  showLabel?: boolean;
  showMetadata?: boolean;
  /** When provided, the badge renders as a button and calls this on click
   * (e.g. to open the signed-off document). Omit for a plain, non-interactive badge. */
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  /** Accessible name for the clickable, icon-only variant. */
  ariaLabel?: string;
}
export default function SignedOff(props) {
  const $ = _c(2);
  const {
    signedOffDate,
    signedOffProviderId
  } = props.signOff;
  if (!signedOffDate || !signedOffProviderId) {
    return null;
  }
  let t0;
  if ($[0] !== props) {
    t0 = <SignedOffDetails {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function SignedOffDetails(t0) {
  const $ = _c(23);
  const {
    signOff,
    className,
    iconClassName,
    showLabel: t1,
    showMetadata: t2,
    onClick,
    ariaLabel
  } = t0;
  const showLabel = t1 === undefined ? true : t1;
  const showMetadata = t2 === undefined ? false : t2;
  const {
    providerName,
    formattedDate,
    tooltipText
  } = useSignOffDetails(signOff);
  let t3;
  if ($[0] !== iconClassName) {
    t3 = cx("inline-block shrink-0", iconClassName);
    $[0] = iconClassName;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3) {
    t4 = <FaCheckCircle className={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== showLabel) {
    t5 = showLabel && <span className="shrink-0">Signed off</span>;
    $[4] = showLabel;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== formattedDate || $[7] !== providerName || $[8] !== showMetadata) {
    t6 = showMetadata && providerName && formattedDate && <span className="min-w-0 truncate text-foreground-secondary">{providerName} · {formattedDate}</span>;
    $[6] = formattedDate;
    $[7] = providerName;
    $[8] = showMetadata;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <>{t4}{t5}{t6}</>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const content = t7;
  let t8;
  if ($[14] !== ariaLabel || $[15] !== className || $[16] !== content || $[17] !== onClick || $[18] !== showLabel) {
    t8 = onClick ? <button type="button" onClick={onClick} aria-label={ariaLabel ?? (showLabel ? undefined : "Signed off")} className={cx(className, "inline-flex min-w-0 max-w-full cursor-pointer items-center gap-1 overflow-hidden whitespace-nowrap text-caption text-status-success-text hover:underline")}>{content}</button> : <span className={cx(className, "inline-flex min-w-0 max-w-full items-center gap-1 overflow-hidden whitespace-nowrap text-caption text-status-success-text")}>{content}</span>;
    $[14] = ariaLabel;
    $[15] = className;
    $[16] = content;
    $[17] = onClick;
    $[18] = showLabel;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8 || $[21] !== tooltipText) {
    t9 = <Tooltip content={tooltipText} triggerAsChild={true} triggerOnlyHover={true}>{t8}</Tooltip>;
    $[20] = t8;
    $[21] = tooltipText;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}